module.exports = "pegasus/assets/column-6-basic.png";